import {useEffect, useState} from "react";
import {Button, Col, Divider, Form, Input, message, Radio, Row, Select, Space} from "antd";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {
    ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION,
    COMMON_DROPDOWN,
    DISTRICTS_LIST,
    IDENTIFICATION_SOURCE,
    MOBILE_NUMBER_MAX_LENGTH,
    ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION,
    ONLY_ALPHABETICAL_PATTERN_VALIDATION,
    ONLY_NUMERIC_VALIDATION,
    PARAMETER_LIST
} from "../../util/Constants";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {AddressDto} from "../../dto/AddressDto";
import Validation from "../../util/Validation";
import {CustomerDto} from "../../dto/CustomerDto";
import customerService from "../../service/customerService";
import ErrorHandler from "../../util/ErrorHandler";
import {MSG_FAILED_TO_FETCH_COUNTRY_LIST_ERROR} from "../../util/Messages";
import {step_2_inactive_img} from '../../../AppImageConst';

interface ContactDetailsPropData {
    savedCusDetailFromPreviousStep: CustomerWrapperDto
    getStepperFilledData: (data: CustomerWrapperDto) => void,
    switchStep?: () => void,
    isFromSummaryView: boolean
}

enum CORRSVALUES {
    YES = "PRIMARY",
    NO = "CORRESPONDENCE",
}

const ContactDetails = (props: ContactDetailsPropData) => {
    const [form] = Form.useForm();
    const [isCorrespondentAddressDisabled, setIsCorrespondentAddressDisabled] = useState(true);
    const [isPassport, setPassport] = useState(false);
    const [selectedAddressType, setSelectedAddressType] = useState<CORRSVALUES | string>();
    const [countryList, setCountryList] = useState<DropdownListDto[]>([]);
    // const [mailingMechodRadio, setMailingMethod] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const [isSriLankaSelected, setSriLankaSelected] = useState(false);
    const [isCorsSriLankaSelected, setCorsSriLankaSelected] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0)
        loadCountryList()
        let customerMstDto = props.savedCusDetailFromPreviousStep.customerMstDto;
        let addressList = customerMstDto.addressList;
        setPassport(IDENTIFICATION_SOURCE.PP == customerMstDto.identificationSource?.sourceType)
        if (null != addressList && addressList.length > 0) {
            setFormValue(customerMstDto)
        } else {
            form.setFieldsValue(
                {
                    email: customerMstDto.email,
                    mobileNo: customerMstDto.mobileNo,
                    type: CORRSVALUES.YES,
                    permanentAddressIdenticalToNicDl: true
                }
            )
        }

    }, [])

    const loadCountryList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.COUNTRY,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setCountryList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_COUNTRY_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const getUpdatedAddressList = (prvAddressList: AddressDto[] | undefined, addressDtoList: AddressDto[]): AddressDto[] => {
        if (undefined !== prvAddressList && undefined != addressDtoList) {
            if (undefined !== prvAddressList[0] && undefined != addressDtoList[0]) {
                addressDtoList[0].id = prvAddressList[0].id
            }
            if (undefined !== prvAddressList[1] && undefined != addressDtoList[1]) {
                addressDtoList[1].id = prvAddressList[1].id
            }
        }
        return addressDtoList;
    }

    const submitSecondStep = (value: any) => {
        //get current customer wrapper object from prop
        let prevDto: CustomerWrapperDto = props.savedCusDetailFromPreviousStep
        let addressDtoList: AddressDto[] = [];
        let customerWrapperDto: CustomerWrapperDto = prevDto;
        let customerMstDto = customerWrapperDto.customerMstDto;

        let primaryAddressDto: AddressDto = {
            line1: value.line1,
            line2: value.line2,
            townOrCity: value.townOrCity,
            district: value.district,
            postalCode: value.postalCode,
            countryId: value.country,
            type: CORRSVALUES.YES,
            permanentAddressIdenticalToNicDl: (IDENTIFICATION_SOURCE.PP == customerMstDto.identificationSource?.sourceType ? true : value.permanentAddressIdenticalToNicDl)
        }
        addressDtoList.push(primaryAddressDto);
        if (CORRSVALUES.NO === selectedAddressType) {
            let corresAddressDto: AddressDto = {
                line1: value.corLine1,
                line2: value.corLine2,
                townOrCity: value.corTownOrCity,
                district: value.corDistrict,
                postalCode: value.corPostalCode,
                countryId: value.corCountry,
                type: CORRSVALUES.NO,
                permanentAddressIdenticalToNicDl: (IDENTIFICATION_SOURCE.PP == customerMstDto.identificationSource?.sourceType ? true : value.permanentAddressIdenticalToNicDl)
            }
            addressDtoList.push(corresAddressDto);
        }

        let customerDto = {} as CustomerDto;
        customerDto.addressList = addressDtoList;
        customerDto.officePhoneNo = value.officePhoneNo;
        customerDto.homePhoneNo = value.homePhoneNo;
        customerDto.faxNo = value.faxNo;



        let addressListLength = undefined != prevDto.customerMstDto.addressList ? prevDto.customerMstDto.addressList.length : 0;
        if (addressListLength > 0) {

            if (validateFieldChanges(prevDto.customerMstDto, customerDto)) {
                customerMstDto.addressList = getUpdatedAddressList(customerMstDto.addressList, addressDtoList);
                customerMstDto.officePhoneNo = value.officePhoneNo;
                customerMstDto.homePhoneNo = value.homePhoneNo;
                customerMstDto.faxNo = value.faxNo;
                // customerMstDto.mailingMethod = mailingMechodRadio;
                customerWrapperDto.recordStatus = "UPDATE";
                customerWrapperDto.isFinalStep = false;
                customerWrapperDto.currentActiveStep = customerWrapperDto.completedStep
                customerWrapperDto.customerMstDto = customerMstDto;

                props.getStepperFilledData(customerWrapperDto);

            } else {
                if (props.switchStep) props.switchStep()
            }
        } else {
            customerMstDto.addressList = addressDtoList;
            customerMstDto.officePhoneNo = value.officePhoneNo;
            customerMstDto.homePhoneNo = value.homePhoneNo;
            customerMstDto.faxNo = value.faxNo;
            customerMstDto.incomeDetail = undefined;
            // customerMstDto.mailingMethod = mailingMechodRadio;
            // customerWrapperDto.completedStep = PageStep.STEP_CONTACT_DETAIL;
            // customerWrapperDto.currentActiveStep = PageStep.STEP_CONTACT_DETAIL;
            customerWrapperDto.recordStatus = "SAVE";
            customerWrapperDto.isFinalStep = false;
            customerWrapperDto.customerMstDto = customerMstDto;

            props.getStepperFilledData(customerWrapperDto);
        }
    }

    const validateFieldChanges = (customerDto: CustomerDto, fieldValues: CustomerDto): boolean => {
        let addressList = undefined === fieldValues.addressList ? [] : fieldValues.addressList;
        if (customerDto.faxNo != fieldValues.faxNo) {
            return true;
        } else if (customerDto.homePhoneNo != fieldValues.homePhoneNo) {
            return true;
        } else if (customerDto.officePhoneNo != fieldValues.officePhoneNo) {
            return true;
        }
        // else if (customerDto.mailingMethod != mailingMechodRadio) {
        //     return true;
        // }
        if (customerDto.addressList?.length != addressList?.length) {
            return true;
        } else if (customerDto.addressList?.length === 1) {
            return validateFieldAddress(customerDto.addressList[0], addressList[0])
        } else if (customerDto.addressList?.length === 2) {
            if (validateFieldAddress(customerDto.addressList[0], addressList[0])) {
                return true;
            }

            if (undefined != customerDto.addressList[1] && undefined == addressList[1]) {
                return true;
            } else if (undefined == customerDto.addressList[1] && undefined != addressList[1]) {
                return true;
            } else {
                return validateFieldAddress(customerDto.addressList[1], addressList[1])
            }
        }
        return false;
    }

    const validateFieldAddress = (addressDto: AddressDto, fieldValues: AddressDto): boolean => {
        if (addressDto.line1 != fieldValues.line1) {
            return true;
        } else if (addressDto.line2 != fieldValues.line2) {
            return true;
        } else if (addressDto.townOrCity != fieldValues.townOrCity) {
            return true;
        } else if (addressDto.district != fieldValues.district) {
            return true;
        } else if (addressDto.countryId != fieldValues.countryId) {
            return true;
        } else if (addressDto.postalCode != fieldValues.postalCode) {
            return true;
        } else if (addressDto.permanentAddressIdenticalToNicDl != fieldValues.permanentAddressIdenticalToNicDl) {
            return true;
        }
        return false;
    }

    const onChange = (e: Event) => {
        let value = (e.target as HTMLInputElement).value as unknown as string;
        setSelectedAddressType(value);
        setIsVisible(!isVisible);
        if (CORRSVALUES.YES === value) {
            setIsCorrespondentAddressDisabled(true);
            form.resetFields(
                ['corLine1',
                    'corLine2',
                    'corTownOrCity',
                    'corDistrict',
                    'corPostalCode',
                    'corCountry']
            );
        } else {
            setIsCorrespondentAddressDisabled(false);
        }
    };

    const setFormValue = (customerDto: CustomerDto) => {
        let addressList = undefined === customerDto.addressList ? [] : customerDto.addressList;
        checkCountry(addressList[0].countryName, CORRSVALUES.YES)
        let formObj: any = {
            line1: addressList[0].line1,
            line2: addressList[0].line2,
            townOrCity: addressList[0].townOrCity,
            district: addressList[0].district,
            country: addressList[0].countryId,
            postalCode: addressList[0].postalCode,
            type: addressList[0].type,
            permanentAddressIdenticalToNicDl: addressList[0].permanentAddressIdenticalToNicDl
        }
        setSelectedAddressType(addressList[0].type)
        if (addressList?.length === 2) {
            formObj.corLine1 = addressList[1].line1;
            formObj.corLine2 = addressList[1].line2;
            formObj.corTownOrCity = addressList[1].townOrCity;
            formObj.corDistrict = addressList[1].district;
            formObj.corCountry = addressList[1].countryId;
            formObj.corPostalCode = addressList[1].postalCode;
            formObj.type = addressList[1].type;
            setSelectedAddressType(addressList[1].type)
            setIsCorrespondentAddressDisabled(false)
            setIsVisible(true)
            checkCountry(addressList[1].countryName, CORRSVALUES.NO)

        }
        formObj.faxNo = customerDto.faxNo;
        formObj.officePhoneNo = customerDto.officePhoneNo;
        formObj.homePhoneNo = customerDto.homePhoneNo;
        formObj.mobileNo = customerDto.mobileNo;
        formObj.email = customerDto.email;
        // formObj.mailingMethod = customerDto.mailingMethod;
        // setMailingMethod(customerDto.mailingMethod??'')
        form.setFieldsValue(formObj)


    }
    // const onChangeMailingMethod=(val:any)=>{
    //     console.log(val);
    //     setMailingMethod(val.target.value);
    // }
    //
    const onCountryChange = (val: string) => {
        form.resetFields(['district'])
        checkCountry(val, CORRSVALUES.YES)
    }
    const onCorsCountryChange = (val: string) => {
        form.resetFields(['corDistrict'])
        checkCountry(val, CORRSVALUES.NO)
    }
    const checkCountry = (val: string | undefined, key: CORRSVALUES) => {
        if (undefined != val) {

            if ("sri lanka" === val.toLowerCase()) {
                CORRSVALUES.YES == key ? setSriLankaSelected(true) : setCorsSriLankaSelected(true)
            } else {
                CORRSVALUES.YES == key ? setSriLankaSelected(false) : setCorsSriLankaSelected(false)
            }
        }
    }


    return (
        <div>
            <p className='step_card_header'>
                <div className="icon-container">
                    <img className='header-icon-img' src={step_2_inactive_img}/>
                </div>
                How Can We Reach You
            </p>
            <Form
                className='form-input'
                layout={"vertical"}
                initialValues={{addressStatus: selectedAddressType}}
                form={form}
                onFinish={submitSecondStep}
                disabled={props.isFromSummaryView}
            >
                <Row gutter={[32, 0]}>
                    <Col span={24}>
                        <h4 className='account-create-form-subheader'>Permanent Address</h4>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Address Line 1"
                            name={"line1"}
                            onKeyPress={Validation.alphanumericAndSpecificSpecialCharacters}
                            rules={!props.isFromSummaryView ? [
                                {required: true, message: 'Please enter address line 1'},
                                {whitespace: true, message: 'Cannot contain whitespaces'},
                                {max: 100, message: 'The maximum length is 100 characters'},
                                {
                                    pattern: ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ] : []}>
                            <Input placeholder="Enter address line 1"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Address Line 2"
                            onKeyPress={Validation.alphanumericAndSpecificSpecialCharacters}
                            name={"line2"}
                            rules={!props.isFromSummaryView ? [
                                {whitespace: true, message: 'Cannot contain whitespaces'},
                                {max: 100, message: 'The maximum length is 100 characters'},
                                {
                                    pattern: ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ] : []}>
                            <Input placeholder="Enter address line 2"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Country"
                            name={"country"}
                            rules={!props.isFromSummaryView ? [{
                                required: true,
                                message: 'Please select country'
                            }] : []}>
                            <Select placement='bottomLeft' placeholder={"Select country"} listHeight={180}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={countryList}
                                    onChange={(input: any, option: {
                                        label: any;
                                    }) => onCountryChange(option?.label.toLowerCase())}
                            />
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="District"
                            name={"district"}
                            onKeyPress={Validation.onlyAlphabeticWithSpace}
                            rules={!props.isFromSummaryView ? [
                                {required: true, message: `Please ${isSriLankaSelected ? 'select' : 'enter'} district`},
                                {whitespace: true, message: 'Cannot contain whitespaces'},
                                {max: 30, message: 'The maximum length is 30 characters'},
                                {
                                    pattern: ONLY_ALPHABETICAL_PATTERN_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ] : []}>
                            {isSriLankaSelected ?
                                <Select placement='bottomLeft' placeholder={"Select district"} listHeight={180}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input: any, option: {
                                            label: any;
                                        }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                        getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                        style={{width: '100%'}}
                                        options={DISTRICTS_LIST}
                                />
                                : <Input placeholder="Enter district"/>}
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Town/ City"
                            name={"townOrCity"}
                            onKeyPress={Validation.onlyAlphabeticWithSpaceAndNumbers}
                            rules={!props.isFromSummaryView ? [
                                {required: true, message: 'Please enter town/city'},
                                {whitespace: true, message: 'Cannot contain whitespaces'},
                                {max: 20, message: 'The maximum length is 20 characters'},
                                {
                                    pattern: ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ] : []}>
                            <Input placeholder="Enter town/city"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Zip Code"
                            name={"postalCode"}
                            onKeyPress={Validation.isNumberWithoutDot}
                            rules={!props.isFromSummaryView ? [{
                                max: 10,
                                message: 'The maximum length is 10 numbers'
                            }, {
                                pattern: ONLY_NUMERIC_VALIDATION,
                                message: 'These special characters are not allowed'
                            }
                            ] : []}>
                            <Input placeholder="Enter zip code"/>
                        </Form.Item>
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        {!isPassport ? <Form.Item className='address_type_select'
                                                  name={"permanentAddressIdenticalToNicDl"} style={{marginBottom: 5}}
                                                  label={"Is the Permanent Address identical to the address on the NIC/Driver's License :"}
                                                  rules={!props.isFromSummaryView ? [{
                                                      required: true,
                                                      message: 'Please select permanent address status'
                                                  }] : []}>
                            <Radio.Group>
                                <Radio value={true}>Yes</Radio>
                                <Radio value={false}>No</Radio>
                            </Radio.Group>
                        </Form.Item> : <></>}

                        <Form.Item className='address_type_select'
                                   name={"type"} style={{marginBottom: 5}}
                                   label={"Is the Correspondence Address the same as Permanent Address :"}
                                   rules={!props.isFromSummaryView ? [{
                                       required: true,
                                       message: 'Please select address status'
                                   }] : []}>
                            <Radio.Group onChange={onChange}>
                                <Radio value={CORRSVALUES.YES}>Yes</Radio>
                                <Radio value={CORRSVALUES.NO}>No</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {isVisible && !props.isFromSummaryView ?
                            <p style={{marginBottom: 24}}> If "<span style={{fontWeight: 'bold'}}>No</span>" the
                                following fields to be completed by the client</p> : <></>}
                    </Col>
                </Row>

                {isVisible &&
                    (
                        <Row gutter={[32, 0]} style={{marginBottom: 8}}>
                            <Col span={24}>
                                <h4 className='account-create-form-subheader'>Correspondence Address</h4>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Address Line 1"
                                    name={"corLine1"}
                                    onKeyPress={Validation.alphanumericAndSpecificSpecialCharacters}
                                    rules={!props.isFromSummaryView ? [
                                        {
                                            required: !isCorrespondentAddressDisabled,
                                            message: 'Please enter address line 1'
                                        },
                                        {whitespace: true, message: 'Cannot contain whitespaces'},
                                        {max: 100, message: 'The maximum length is 100 characters'},
                                        {
                                            pattern: ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION,
                                            message: 'These special characters are not allowed'
                                        }
                                    ] : []}>
                                    <Input placeholder="Enter address line1"
                                           disabled={isCorrespondentAddressDisabled || props.isFromSummaryView}/>
                                </Form.Item>
                            </Col>

                            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Address Line 2"
                                    name={"corLine2"}
                                    onKeyPress={Validation.alphanumericAndSpecificSpecialCharacters}
                                    rules={!props.isFromSummaryView ? [
                                        {whitespace: true, message: 'Cannot contain whitespaces'},
                                        {max: 100, message: 'The maximum length is 100 characters'},
                                        {
                                            pattern: ALPHANUMERIC_AND_SPECIFIC_SPECIAL_CHARACTERS_VALIDATION,
                                            message: 'These special characters are not allowed'
                                        }
                                    ] : []}>
                                    <Input placeholder="Enter address line2"
                                           disabled={isCorrespondentAddressDisabled || props.isFromSummaryView}/>
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="Country"
                                    name={"corCountry"}
                                    rules={!props.isFromSummaryView ? [{
                                        required: !isCorrespondentAddressDisabled,
                                        message: 'Please select country'
                                    }] : []}>
                                    <Select placement='bottomLeft' placeholder={"Select country"} listHeight={180}
                                            disabled={isCorrespondentAddressDisabled || props.isFromSummaryView}
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input: any, option: {
                                                label: any;
                                            }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                            style={{width: '100%'}}
                                            options={countryList}
                                            onChange={(input: any, option: {
                                                label: any;
                                            }) => onCorsCountryChange(option?.label.toLowerCase())}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="District"
                                    name={"corDistrict"}
                                    onKeyPress={Validation.onlyAlphabeticWithSpace}
                                    rules={!props.isFromSummaryView ? [
                                        {
                                            required: !isCorrespondentAddressDisabled,
                                            message: `Please ${isCorsSriLankaSelected ? 'select' : 'enter'} district`
                                        },
                                        {whitespace: true, message: 'Cannot contain whitespaces'},
                                        {max: 30, message: 'The maximum length is 30 characters'},
                                        {
                                            pattern: ONLY_ALPHABETICAL_PATTERN_VALIDATION,
                                            message: 'These special characters are not allowed'
                                        }
                                    ] : []}>
                                    {isCorsSriLankaSelected ?
                                        <Select placement='bottomLeft' placeholder={"Select district"} listHeight={180}
                                                showSearch
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').startsWith(input.toLowerCase())}
                                                getPopupContainer={(trigger: {
                                                    parentNode: any;
                                                }) => trigger.parentNode}
                                                style={{width: '100%'}}
                                                options={DISTRICTS_LIST}
                                        />
                                        :
                                        <Input placeholder="Enter district"
                                               disabled={isCorrespondentAddressDisabled || props.isFromSummaryView}/>}
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="Town/ City"
                                    name={"corTownOrCity"}
                                    onKeyPress={Validation.onlyAlphabeticWithSpaceAndNumbers}
                                    rules={!props.isFromSummaryView ? [
                                        {required: !isCorrespondentAddressDisabled, message: 'Please enter town/city'},
                                        {whitespace: true, message: 'Cannot contain whitespaces'},
                                        {max: 20, message: 'The maximum length is 20 characters'},
                                        {
                                            pattern: ONLY_ALPHABETICAL_AND_NUMBERS_PATTERN_VALIDATION,
                                            message: 'These special characters are not allowed'
                                        }
                                    ] : []}>
                                    <Input placeholder="Enter town/city"
                                           disabled={isCorrespondentAddressDisabled || props.isFromSummaryView}/>
                                </Form.Item>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                                <Form.Item
                                    label="Zip Code"
                                    name={"corPostalCode"}
                                    onKeyPress={Validation.isNumberWithoutDot}
                                    rules={!props.isFromSummaryView ? [{
                                        max: 10,
                                        message: 'The maximum length is 10 numbers'
                                    },
                                        {
                                            pattern: ONLY_NUMERIC_VALIDATION,
                                            message: 'These special characters are not allowed'
                                        }
                                    ] : []}>
                                    <Input placeholder="Enter zip code"
                                           disabled={isCorrespondentAddressDisabled || props.isFromSummaryView}/>
                                </Form.Item>
                            </Col>
                        </Row>
                    )
                }


                <Row gutter={[32, 0]}>
                    <Col span={24}>
                        <h4 className='account-create-form-subheader'>Contact Details</h4>
                    </Col>
                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Mobile Number"
                            name={"mobileNo"}
                            rules={!props.isFromSummaryView ? [
                                {required: true, message: 'Please enter mobile number'}] : []}>
                            <Input disabled placeholder="Enter mobile number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Fax"
                            name={"faxNo"}
                            onKeyPress={Validation.isNumberWithoutDot}
                            rules={!props.isFromSummaryView ?
                                [
                                    {max: MOBILE_NUMBER_MAX_LENGTH, message: 'The maximum length is 15 numbers'},
                                    {
                                        pattern: ONLY_NUMERIC_VALIDATION,
                                        message: 'These special characters are not allowed'
                                    }
                                ] : []}>
                            <Input placeholder="Enter fax number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Office Phone Number"
                            name={"officePhoneNo"}
                            onKeyPress={Validation.isNumberWithoutDot}
                            rules={!props.isFromSummaryView ?
                                [
                                    {max: MOBILE_NUMBER_MAX_LENGTH, message: 'The maximum length is 15 numbers'},
                                    {
                                        pattern: ONLY_NUMERIC_VALIDATION,
                                        message: 'These special characters are not allowed'
                                    }
                                ] : []}>
                            <Input placeholder="Enter office phone number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={6} xl={6} lg={12} md={12} sm={12} xs={24}>
                        <Form.Item
                            label="Residential Phone Number"
                            name={"homePhoneNo"}
                            onKeyPress={Validation.isNumberWithoutDot}
                            rules={!props.isFromSummaryView ?
                                [
                                    {max: MOBILE_NUMBER_MAX_LENGTH, message: 'The maximum length is 15 numbers'},
                                    {
                                        pattern: ONLY_NUMERIC_VALIDATION,
                                        message: 'These special characters are not allowed'
                                    }
                                ] : []}>
                            <Input placeholder="Enter residential phone number"/>
                        </Form.Item>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Form.Item
                            label="Email"
                            name={"email"}
                            rules={!props.isFromSummaryView ? [{required: true, message: 'Please enter email'}] : []}>
                            <Input disabled placeholder="Enter email"/>
                        </Form.Item>
                    </Col>

                    {/*<Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>*/}
                    {/*    <Form.Item*/}
                    {/*        label="Confirmations & Statements Will Be Sent Via,"*/}
                    {/*        name={"mailingMethod"}*/}
                    {/*        rules={!props.isFromSummaryView ? [{required: true, message: 'Please enter confirmation and statement send method'}] : ''}>*/}
                    {/*        <Radio.Group onChange={onChangeMailingMethod} >*/}
                    {/*            <Radio value="EMAIL">Email</Radio>*/}
                    {/*            <Radio value="POST">Post</Radio>*/}
                    {/*        </Radio.Group>*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                </Row>
                {
                    !props.isFromSummaryView ?
                        <>
                            <Row>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    <Divider></Divider>
                                </Col>
                            </Row>
                            <Space style={{float: 'right'}} className='form_next_btn_col'>
                                <Form.Item>
                                    <Button className='form_next_btn' htmlType="submit" type="primary">
                                        Next
                                    </Button>
                                </Form.Item>
                            </Space>
                        </> : ''
                }

            </Form>

        </div>
    )

}
export default ContactDetails;

